module.exports = __webpack_public_path__ + "img/firstTopAnswer.2b8a1948.svg";